import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowWallDown: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-wall-down, align bottom"><path d="M16.25 13L12 17.25L7.75 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.25 21.25H4.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 2.75L12 16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowWallDown;
